<template>
  <main class="overflow-hidden h-screen">
    <div class="h-full flex items-center">
      <div class="md:w-1/3 lg:w-1/3 w-full flex justify-center items-center bg-white ">
        <div class="w-full my-10">
          <transition name="form-content">
            <img v-if="show" src="../assets/eventName.png" class="mx-auto md:hidden lg:hidden w-40 mt-5">
          </transition>
          <form id="form" @submit.prevent="register">
              <div class="flex md:flex-row lg:flex-row flex-col m-7 lg:px-20 md:px-10">
                <transition name="form-content">
                <div v-if="show" class="min-w-100 w-full">
                  <h3 class="text-3xl font-bold fira text-gray-500 lg:text-red-500 md:text-red-500 mb-5">PRE SIGN UP</h3>
                  <typical
                    class="typicalWrapper hidden lg:block sm:block h-10 italic text-sm text-gray-500 my-2"
                    :steps="['Sign up now to be notified', 1000, 'TAYTB Virtual Fest 2021', 1000]"
                    :loop="Infinity"
                    :wrapper="'h3'"
                  ></typical>
                  <div class="mb-6 flex flex-col">
                      <label class="font-normal text-left text-gray-700 pl-2">Full Name</label>
                      <input
                      v-model="user.name"
                      type="text" name="name" id="name" required
                      autofocus="autofocus"
                      class="border border-gray-400 w-full p-2 rounded mt-2 focus:outline-none focus:border-red-700">
                  </div>
                  <div class="mb-6 flex flex-col">
                    <label class="font-normal text-left text-gray-700 pl-2">Email</label>
                    <input
                      v-model="user.email"
                      type="email" name="email" id="email" required
                      autofocus="autofocus"
                      class="border border-gray-400 w-full p-2 rounded mt-2 focus:outline-none focus:border-red-700"/>
                  </div>
                  <div class="mb-6 flex flex-col">
                    <label class="font-normal text-left text-gray-700 pl-2">Password</label>
                    <input
                      v-model="user.password"
                      type="password" name="password" id="password" required
                      autofocus="autofocus"
                      class="border border-gray-400 w-full p-2 rounded mt-2 focus:outline-none focus:border-red-700"/>
                  </div>
                  <div class="mb-6 flex flex-col">
                    <label class="font-normal text-left text-gray-700 pl-2">Confirm Password</label>
                    <input
                      v-model="user.confirmPassword"
                      type="password" name="password" id="password" required
                      autofocus="autofocus"
                      class="border border-gray-400 w-full p-2 rounded mt-2 focus:outline-none focus:border-red-700"/>
                  </div>
                  <div class="mb-6 flex flex-col">
                    <label class="font-normal text-left text-gray-700 pl-2">Phone Number</label>
                    <div class="flex justify-center w-full">
                      <div class="p-2 rounded mt-2 w-10">
                        <p class="text-gray-500 font-bold italic text-lg">+62</p>
                      </div>
                      <input
                        v-model="user.confirmPassword"
                        type="password" name="password" id="password" required
                        autofocus="autofocus"
                        class="border border-gray-400 w-full ml-1 rounded mt-2 focus:outline-none focus:border-red-700"/>
                    </div>
                  </div>
                  <div class="flex flex-col text-gray-500">
                    <div class="flex flex-row">
                      <input
                      v-model="user.status"
                      class="inline mr-2 mt-1"
                      type="radio" id="nasabah" value="Nasabah">
                      <label class="text-left inline" for="nasabah">Nasabah</label>
                    </div>
                     <div class="flex flex-row">
                      <input
                      v-model="user.status"
                      class="inline mr-2 mt-1"
                      type="radio" id="non-nasabah" value="Non Nasabah">
                      <label class="text-left inline" for="non-nasabah">Non Nasabah</label>
                    </div>
                  </div>
                  <div
                  v-if="user.status === 'Nasabah'"
                  class="mb-6 border-b">
                    <label for="bankAccount" class="block mb-2 text-sm font-bold text-gray-600 text-left">Bank Account</label>
                      <input
                      v-model="user.bankAccount"
                      type="text" name="bankAccount" id="bankAccount" placeholder="e.g: 60432" required class=" text-gray-700 bg-transparent py-3 focus:ring-2 focus:ring-gray-300 w-full" />
                  </div>
                </div>
                </transition>
                </div>
                <transition name="button-content">
                  <div v-if="show" class="mb-6 mx-auto lg:px-20 md:px-10 px-5">
                      <button type="submit" class="bg-red-600 w-full rounded py-2 shadow-lg text-white font-semibold hover:bg-red-700 hover:text-gray-200">SUBMIT</button>
                  </div>
                </transition>
              </form>
        </div>
      </div>
      <div class="md:block lg:block hidden w-2/3 p-20">
        <transition name="zoom-fade">
          <img v-if="show" src="../assets/bg-pattern.png" class="h-screen absolute">
        </transition>
        <transition name="slide-content">
          <div v-if="show" class="w-full flex justify-center flex-col">
            <img src="../assets/virtualIsland.png" alt="TAYTB Virtual Island"
            class="relative zIsland w-full island mx-auto island">
          </div>
        </transition>
        <transition name="slide-content">
          <div v-if="show" class="w-full p-5 flex relative zIsland flex-col mt-10 items-center justify-center event-info">
              <img src="../assets/eventName.png" class="my-2 eventName"/>
          </div>
        </transition>
        </div>
    </div>
  </main>
</template>

<script>
import typical from 'vue-typical'

export default {
  name: 'PreSignUp',
  data () {
    return {
      user: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        phone: '',
        status: '',
        bankAccount: ''
      },
      show: false
    }
  },
  components: {
    typical
  },
  mounted () {
    this.show = !this.show
  },
  methods: {
    register () {
      if (this.user.password === this.user.confirmPassword) {
        this.$store.dispatch('registerUser', this.user)
      } else {
        console.log('password not match')
      }
    },
    leavePage () {
      this.show = !this.show
      setTimeout(() => this.$router.push({ path: '/register' }), 1000)
    }
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Fira+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,700;1,800;1,900&display=swap');
  main, .fira {
    font-family: 'Fira Sans', sans-serif;
  }
  form input {
    padding: 0 5px;
    margin-left: 10px;
  }
  .left-content {
  background-image: url("https://www.taytb.com/assets/eabussiness/dist/img/bg-section1-5.png");
  background-color: #cccccc;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  }
/* island */
  .form-content-enter-active {
    transition: all 1s ease;
    transition-delay: .4s;
  }
  .form-content-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .form-content-enter
  /* .form-content-leave-active below version 2.1.8 */ {
    transform: translateY(-50px);
    opacity: 0;
  }
  .form-content-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
  /* content */
  .island-content-enter-active {
    transition: all 1s ease;
    transition-delay: .6s;
  }
  .island-content-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .island-content-enter, .island-content-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
  /* Button */
  .button-content-enter-active {
    transition: all 1s ease;
    transition-delay: .2s;
  }
  .button-content-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .button-content-enter, .button-content-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
  /* content */
  .slide-content-enter-active {
    transition: all 1s ease;
    transition-delay: .8s;
  }
  .slide-content-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-content-enter, .slide-content-leave-to {
    transform: translateX(50px);
    opacity: 0;
  }
  .island, .eventName {
    max-width: 50%;
  }
</style>
